module.exports = __webpack_public_path__ + "static/media/empty-avatar.f4eb2a3e.jpg";